module.exports = __webpack_public_path__ + "img/addscience.b0975fd6.png";